<script>
export default {
  name: 'QueryFilterMixin',
  data: () => ({
  }),
  methods: {
    async removeRouterData (routerData) {
      // this.$router.replace()

      this.$router.replace({
        ...this.$router.currentRoute,
        ...routerData
      })

      window.location.reload()
    },
    async updateRouteData (routerData) {
      this.$router.replace({
        ...this.$router.currentRoute,
        ...routerData
      })
    },
  },
}
</script>
